import { Injectable, OnDestroy } from '@angular/core';
import { environment } from 'projects/shared/environments/environment';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import { Observable, BehaviorSubject, Subject, takeUntil, tap, noop } from 'rxjs';
import type { Socket } from 'socket.io-client';

interface SocketQueryParams {
  userId: string;
  [key: string]: string | undefined;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationSocketService {
  private baseURL = `${environment.apiUrl.replace('v1/', '')}`

  private readonly BASE_URL = `${this.baseURL}notifications`;
  private socket!: Socket;
  private connecting = false;
  newNotification = new BehaviorSubject<any>({})
  private nameSpace = 'notifications'
  constructor(private _storeChangesService: StoreChangesService) {
  }

  initSocket(userId: string): void {
    // Prevent multiple initializations
    if (this.socket || this.connecting) {
      return;
    }
    this.connecting = true;
    // socket.io-client is only needed once a user is logged in, so it is kept out of the main bundle.
    import('socket.io-client').then(({ io }) => {
      this.socket = io(`${this.BASE_URL}`, {
        transports: ['websocket'],
        query: { userId },
      });
      this.onSocketConnect(userId)
    });
  }


  onSocketConnect(userId: string) {
    if (this.socket) this.socket.on('connect', () => {
      this.joinToRoom('joinRoom', userId);
    });
  }

  joinToRoom(room: string, userId: string) {
    if (this.socket) {
      this.socket.emit(room, userId);
    }
    else return;
    this.onNewNotification();

  }
  onNewNotification() {
    if (this.socket) this.socket.on('newNotification', data => {
      this.newNotification.next(data);
    })
  }



}